import { createSelector } from 'reselect';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';
import { showSelector } from 'selectors/testTarget/offers/atbCarouselsPDP/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAtbCarouselsPDPSelector = createSelector(
    isTestTargetReadySelector,
    showSelector,
    isAnonymousSelector,
    (testReady, show, isAnonymous) => testReady && show && !isAnonymous
);

export { showAtbCarouselsPDPSelector };
